const moveFolder = {
    svg: '<svg style="width:1.00rem; height:1.00rem;"><path d="M16 4.933V15.6H0V4.933zm-1.2 1.2H1.2V14.4h13.6zM8.08 7.25l2.597 2.597H8.61l.001 3.528H7.546l.003-3.528H5.482zM6.21.667l1.29 1.69H16V4H0V.667z"/></svg>',
};

export { moveFolder as default };
